import {Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IrbEditorComponent} from "@irb/irb-editors/irb-editors.com";
import {
    IPortfolioResultPFSECRebal,
    IPortfolioResultResponse,
    SecurityTradeActionNote
} from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model";
import {ComPrAllocationsGridLayoutService} from "@irb/irb-editors/editor-portfolio-result/com-pr-allocations/com-pr-allocations.grid-layout.service";
import {PrAllocationsService} from "@irb/irb-editors/editor-portfolio-result/services";
import {CellClickedEvent, ProcessCellForExportParams} from 'ag-grid-community';
import {DialogComponent} from '@irb-common/components/dialog/dialog.component';
import {SecurityComponentsDialogComponent} from '@irb/irb-editors/editor-security/security-components-dialog/security-components-dialog.component';
import {IrbAppEvents} from '@irb/app.events';
import {IAlertDialogData} from '@irb/app.model';
import {IrbDialogsEvents} from '@irb/irb-dialogs/irb-dialogs.events';
import {IEvent} from "@irb-common/events";
import {IrbSettingsService} from "@irb/irb-settings/irb-settings.service";
import { IrbCommonModule } from "@irb/irb-common/irb-common.module";
import { JasperSettings, ISortModel } from "@irb/irb-dialogs/dialog-pr-export-pdf/dialog-pr-export-pdf.component";

@Component({
    selector: "irb-com-pr-allocations",
    templateUrl: "./com-pr-allocations.component.html",
    styleUrls: ["./com-pr-allocations.component.scss"],
    standalone: true,
    imports: [CommonModule, IrbCommonModule]
})
export class ComPrAllocationsComponent extends IrbEditorComponent implements OnInit {
    @ViewChild("groupDropdown") groupDropdown: any;
    @ViewChild('comPrAllocationTemplate') comPrAllocationTemplate: TemplateRef<any>;
    @ViewChild('securityTradeActionNoteTemplate') securityTradeActionNoteTemplate: TemplateRef<any>;
    @ViewChild("dialogPrComAlloc") dialogPrComAlloc: DialogComponent;

    @Output() change = new EventEmitter<boolean>();
    @Input() groupOption: string;
    @Input() canTransmitData: boolean = false;
    @Input() canReceiveData: boolean = false;
    @Input() pdfExportConfig: JasperSettings = {} as JasperSettings;
    @Output() pdfExportConfigChange = new EventEmitter<JasperSettings>();

    _data: IPortfolioResultResponse;
    snapShotData: IPortfolioResultResponse;
    grid: any;
    gridOptions: any;
    frameworkComponents: any;
    domLayout: any = 'autoHeight';
    columnMode: string;
    gridHeight = '700px';
    comPrAllocationTemplateContent: string;
    securityTradeActionNoteTemplateContent: string;
    componentName: string;
    componentNameGrouped: string;
    componentNameUngrouped: string;
    isUnitTest = false;
    popupParent:any;

    constructor(private gls: ComPrAllocationsGridLayoutService, public pralloc: PrAllocationsService, public iss: IrbSettingsService,) {
        super();
    }

    @Input()
    get data(): any {
        return this._data;
    }

    set data(d: any) {
        if (d.secRebalDTOList && d.secRebalDTOList.length !== 0 && d.pfSecRebalDTOList && d.pfSecRebalDTOList.length !== 0) {
            const groupSecurities = d.secRebalDTOList.filter((x: any) => x.rebalCompSecurityDTOList?.length !== 0);
            if (groupSecurities && groupSecurities.length !== 0) {
                groupSecurities.forEach((grSec: any) => {
                    for (let i = 0; i < d.pfSecRebalDTOList.length; i++) {
                        if (grSec.securityId === d.pfSecRebalDTOList[i].secId) {
                            d.pfSecRebalDTOList[i].rebalCompSecurityDTOList = grSec.rebalCompSecurityDTOList;
                            break;
                        }
                    }
                });
            }
        }

        this._data = d;
        this.update();
    }

    ngOnInit() {
        super.ngOnInit();

        this.popupParent = document.querySelector("body");
        this.columnMode = this.as.getFromSession("PRD_ALLOCATIONS_COLUMN_MODE","secDolrVariance");
        this.pralloc.showEquivalents = false;
        this.pralloc.group = this.groupOption;
        this.pralloc.showExcluded = this.as.getFromSession("PRD_ALLOCATIONS_SHOW_EXCLUDED", false);
        this.pralloc.assetClassDetail1 = this.as.getFromSession("PRD_ALLOCATIONS_ASSET_CLASS_DETAIL1", true);
        this.pralloc.assetClassDetail2 = this.as.getFromSession("PRD_ALLOCATIONS_ASSET_CLASS_DETAIL2", true);
        this.pralloc.assetClassDetail3 = this.as.getFromSession("PRD_ALLOCATIONS_ASSET_CLASS_DETAIL3", true);
        this.pralloc.assetClassDetail4 = this.as.getFromSession("PRD_ALLOCATIONS_ASSET_CLASS_DETAIL4", true);
        this.componentNameGrouped = "portfolioResultSummaryAllocations-Grouped-" + this.groupOption + "-v001";
        this.componentNameUngrouped = "portfolioResultSummaryAllocations-Ungrouped-" + this.groupOption + "-v001";
        this.checkForEquivalents();
        this.componentName = (this.pralloc.showEquivalents) ? this.componentNameGrouped : this.componentNameUngrouped;
        this.snapShotData = this.util.clone(this._data);
        this.pralloc.appendEquivalents(this.snapShotData);
        this.pralloc.appendSecCategories(this.snapShotData);
        this.pralloc.appendStyleBoxLabels(this.snapShotData);
        this.pralloc.appendSecurityTypes(this.snapShotData);
        this.pralloc.appendACLevels(this.snapShotData);

        this.pdfExportConfig.showAllcnExcludedPositions = this.pralloc.showExcluded;
        this.pdfExportConfig.showAllcnGroupEquivalents = this.pralloc.showEquivalents;
        this.pdfExportConfig.assetClassDetail1 = this.pralloc.assetClassDetail1;
        this.pdfExportConfig.assetClassDetail2 = this.pralloc.assetClassDetail2;
        this.pdfExportConfig.assetClassDetail3 = this.pralloc.assetClassDetail3;
        this.pdfExportConfig.assetClassDetail4 = this.pralloc.assetClassDetail4;
        this.pdfExportConfigChange?.emit(this.pdfExportConfig);

        this.gridOptions = {
            columnDefs: this.gls.getColumnDefs(this),
            aggFuncs: this.gls.getAggFuncs(this),
            floatingFilter: false,
            context: {componentParent: this},
            isExternalFilterPresent: () => true,
            doesExternalFilterPass: this.filterGrid.bind(this),
            suppressAggFuncInHeader: true,
            onRowGroupOpened: () => this.updateGridLayout(),
            processCellForClipboard: this.processCellForClipboard.bind(this),
            postSortRows: this.onPostSort.bind(this),
            onCellClicked:  this.onPrAllocationsCellClicked.bind(this),
            treeData: this.pralloc.group === 'sacSecurityType' || this.pralloc.group === 'styleBoxLabel' || this.pralloc.group === 'SecCustCatAllocLabel' || this.pralloc.group === 'ACLevel' || (this.pralloc.group === 'ungroupedAllocLabel' && this.pralloc.showEquivalents),
            treeDataDisplayType: 'custom',
            getDataPath: (data: IPortfolioResultPFSECRebal) => {
                if(this.pralloc.group === 'SecCustCatAllocLabel') {
                    return (data.secId && data.secType != "UI_GROUP") ? [data.secCatagory, data.secId.toString()] : [data.secCatagory];
                } else if(this.pralloc.group === 'styleBoxLabel') {
                    return (data.secId && data.secType != "UI_GROUP") ? [data.styleBoxLabel || "Uncategorized", data.secId.toString()] : [data.styleBoxLabel || "Uncategorized"];
                } else if(this.pralloc.group === 'sacSecurityType') {
                    return (data.secId && data.secType != "UI_GROUP") ? [data.sacSecurityType || "Uncategorized", data.secId.toString()] : [data.sacSecurityType || "Uncategorized"];
                } else if(this.pralloc.group === 'ACLevel') {
                    return (data.secId && data.secType != "UI_GROUP") ? data.path?.concat(data.secId.toString()) || [data.secId.toString()] : data.path;
                } else if(this.pralloc.group === 'ungroupedAllocLabel' && this.pralloc.showEquivalents) {
                    if(data.secId && data.secType != "UI_GROUP") {
                        if(data.isEquivalentChild) {
                            return ['UI_GROUP_FOR_' + data.parentSecSymb, data.secSymb];
                        } else if(data.isEquivalentParent) {
                            return ['UI_GROUP_FOR_' + data.secSymb, data.secSymb];
                        } else {
                            return [data.secSymb];
                        }
                    } else {
                        return ['UI_GROUP_FOR_' + data.secSymb];
                    }
                } else {
                    return [data.secId.toString()];
                }
            },
            getRowId: (params: any) => {
                return params.data.secId;
            },
            excludeChildrenWhenTreeDataFiltering: true
        } as any;

        //this.gridOptions.groupRemoveSingleChildren = this.pralloc.group === 'ungroupedAllocLabel' && this.pralloc.showEquivalents;

        this.frameworkComponents = this.gls.getFrameworkComponents();
        this.change.emit(true);

        if(this.canReceiveData) {
            const bc = new BroadcastChannel('IRB_PRD_CHANNEL');

            bc.onmessage = event => {
                if(event.origin === window.location.origin) {
                    this.data = event.data as IPortfolioResultResponse;
                    this.update();
                }
            }
        }
    }

    processEvent(event: IEvent): void {
        super.processEvent(event);

        switch (event.type) {
            case IrbAppEvents.GRID_REFRESH:
                this.updateSecurityCustomAttrAbbr();
                break;
        }
    }

    onDataChange() {
        this.update();
    }

    updateSecurityCustomAttrAbbr() {
        this.iss.getGlobalSettings().subscribe((globalSettings: any) => {
            this.data.envGlobalSettingsDTO.securityCustAttrAbbr = globalSettings.securityCustAttrAbbr;
            this.pdfExportConfig.allcnGroupCCName = this.pdfExportConfig.chartGroupCCName = this.data.envGlobalSettingsDTO.securityCustAttrAbbr;
            this.pdfExportConfigChange?.emit(this.pdfExportConfig);
        });
    }

    update() {
        this.snapShotData = this.util.clone(this.data);
        this.pralloc.appendEquivalents(this.snapShotData);
        this.pralloc.appendSecCategories(this.snapShotData);
        this.pralloc.appendStyleBoxLabels(this.snapShotData);
        this.pralloc.appendSecurityTypes(this.snapShotData);
        this.pralloc.appendACLevels(this.snapShotData);

        if (this.grid) {
            this.grid.api.setGridOption('rowData', this.snapShotData.pfSecRebalDTOList);
            //this.grid.api.refreshHeader();
            //this.grid.api.refreshClientSideRowModel('aggregate');
            this.updateGridFooter();
            this.updateGridLayout();
            //this.grid.api.redrawRows();
        }

        if(this.canTransmitData) {
            const bc = new BroadcastChannel('IRB_PRD_CHANNEL');
            bc.postMessage(this.data);
        }
    }

    onDataLoad() {
        super.onDataLoad();
        this.update();
    }

    onGridReady(params: any) {
        this.grid = params;
        this.updateGridFooter();
        this.updateGridLayout();
    }

    updateGridLayout() {
        if (this.grid && this.grid.api) {
            const rows = this.grid.api.getDisplayedRowCount() + this.grid.api.getPinnedBottomRowCount();
            this.domLayout = rows > 20 || rows < 8 ? 'normal' : 'autoHeight';
            if(rows < 8) {
                this.gridHeight = '300px';
            } else if (rows > 20 ) {
                this.gridHeight = '700px';
            } else {
                this.gridHeight = '100%';
            }

            this.grid.api.setGridOption('domLayout', this.domLayout);
        }
    }

    isAllInRange(paramKey: string) {
        let inRangeCount = 0, p: string;;
        const items: Array<IPortfolioResultPFSECRebal> = this.pralloc.getFilteredItems(this.data);

        items.forEach((r: IPortfolioResultPFSECRebal) => {
            if(this.pralloc.showEquivalents && r.isEquivalentParent) {
                if(paramKey == "isWithinRangeBefore") {
                    p = "isEquivalentParentWithinRangeBefore";
                } else if(paramKey == "isWithinRangeAfter") {
                    p = "isEquivalentParentWithinRangeAfter";
                }
            } else {
                p = paramKey;
            }

            if (this.util.getObjectValue(r, p)) {
                inRangeCount++;
            }
        });

        return inRangeCount === items.length;
    }

    getInRangeCount(paramKey: string) {
        let inRangeCount = 0, p: string;
        const items: Array<IPortfolioResultPFSECRebal> = this.pralloc.getFilteredItems(this.data);

        items.forEach((r: IPortfolioResultPFSECRebal) => {
            if(this.pralloc.showEquivalents && r.isEquivalentParent) {
                if(paramKey == "isWithinRangeBefore") {
                    p = "isEquivalentParentWithinRangeBefore";
                } else if(paramKey == "isWithinRangeAfter") {
                    p = "isEquivalentParentWithinRangeAfter";
                }
            } else {
                p = paramKey;
            }

            if (this.util.getObjectValue(r, p)) {
                inRangeCount++;
            }
        });

        return inRangeCount + " of " + items.length;
    }

    updateGridFooter() {
        const footerData: Partial<IPortfolioResultPFSECRebal> = {
            secSymb: '',
            secMktVal: this.data.mktVal,
            secCurPercntVal: 0,
            secMktValAfterAdj: 0,
            secPercntValAfterAdj: 0
        };

        const exclusionFooterData: Partial<IPortfolioResultPFSECRebal> = {
            secSymb: 'with Exclusions',
            secMktVal: this.data.mktValWithXcludedPosns,
            secMktValAfterAdj: this.data.mktValWithXcludedPosnsAfterAdj
        };

        this.data.pfSecRebalDTOList?.forEach((r: IPortfolioResultPFSECRebal) => {
            if (!r.secExclusionType && !r.isEquivalentChild) {
                footerData.secCurPercntVal += r.secCurPercntVal;
                footerData.secMktValAfterAdj += r.secMktValAfterAdj;
                footerData.secPercntValAfterAdj += r.secPercntValAfterAdj;
            }
        });

        this.grid.api.setGridOption('pinnedBottomRowData',this.data.isAllocationExcludedPositionRecordsPresent ? [footerData, exclusionFooterData] : [footerData]);
    }

    setColumnMode(m: string) {
        this.columnMode = m;this.as.setToSession("PRD_ALLOCATIONS_COLUMN_MODE", this.columnMode);
        this.grid.api.setGridOption('columnDefs', this.gls.getColumnDefs(this));
    }

    setShowExcluded() {
        this.snapShotData = this.util.clone(this.data);
        setTimeout(() => this.update());
        
        this.change.emit(true);
        this.grid.api.onFilterChanged();
        this.as.setToSession("PRD_ALLOCATIONS_SHOW_EXCLUDED", this.pralloc.showExcluded);
        this.updateGridLayout();
        this.grid.api.redrawRows();
        this.pdfExportConfig.showAllcnExcludedPositions = this.pralloc.showExcluded;
        this.pdfExportConfigChange?.emit(this.pdfExportConfig);
    }

    setAssetClassDetail() {
        this.snapShotData = this.util.clone(this.data);
        setTimeout(() => this.update());
        this.as.setToSession("PRD_ALLOCATIONS_ASSET_CLASS_DETAIL1", this.pralloc.assetClassDetail1);
        this.as.setToSession("PRD_ALLOCATIONS_ASSET_CLASS_DETAIL2", this.pralloc.assetClassDetail2);
        this.as.setToSession("PRD_ALLOCATIONS_ASSET_CLASS_DETAIL3", this.pralloc.assetClassDetail3);
        this.as.setToSession("PRD_ALLOCATIONS_ASSET_CLASS_DETAIL4", this.pralloc.assetClassDetail4);
        this.updateGridLayout();
        this.grid.api.redrawRows();
        this.pdfExportConfig.assetClassDetail1 = this.pralloc.assetClassDetail1;
        this.pdfExportConfig.assetClassDetail2 = this.pralloc.assetClassDetail2;
        this.pdfExportConfig.assetClassDetail3 = this.pralloc.assetClassDetail3;
        this.pdfExportConfig.assetClassDetail4 = this.pralloc.assetClassDetail4;
        this.pdfExportConfigChange?.emit(this.pdfExportConfig);
    }

    setShowEquivalents() {
        this.snapShotData = this.util.clone(this.data);
        setTimeout(() => this.update());
        
        this.componentName = (this.pralloc.showEquivalents) ? this.componentNameGrouped : this.componentNameUngrouped;
        //this.gridOptions.groupRemoveSingleChildren = this.pralloc.group === 'ungroupedAllocLabel' && this.pralloc.showEquivalents;
        //this.gridOptions.treeData = this.pralloc.group === 'SecCustCatAllocLabel' || this.pralloc.group === 'ACLevel' || (this.pralloc.group === 'ungroupedAllocLabel' && this.pralloc.showEquivalents),
        this.grid.api.setGridOption('columnDefs', this.gls.getColumnDefs(this));
        this.grid.api.refreshHeader();
        this.grid.api.onFilterChanged();
        this.change.emit(true);
        this.updateGridLayout();
        this.grid.api.redrawRows();

        this.pdfExportConfig.showAllcnGroupEquivalents = this.pralloc.showEquivalents;
        this.pdfExportConfigChange?.emit(this.pdfExportConfig);
    }

    /*setGroup() {
        this.pralloc.group = this.groupOption;
        this.grid.api.setGridOption('columnDefs', this.gls.getColumnDefs(this));
        this.gridOptions.groupRemoveSingleChildren = this.pralloc.group === 'ungroupedAllocLabel' && this.pralloc.showEquivalents;
        this.grid.api.setGridOption("autoGroupColumnDef",this.gls.getAutoGroupColumnDef(this));
        this.grid.api.onFilterChanged();
        this.as.setToSession("PRD_ALLOCATIONS_GROUP", this.pralloc.group);
        this.updateGridLayout();
        this.grid.api.redrawRows();
    }*/

    filterGrid(node: any) {
        let f = true;

        if(!node.data) {
            return true;
        }

        if (!this.pralloc.showExcluded) {
            f = f && !node.data.secExclusionType;
        }

        if (this.pralloc.showEquivalents && this.pralloc.group === 'ungroupedAllocLabel') {
            f = f && !(node.data.isEquivalent && !node.data.isEquivalentChild);
        } else {
            f = f && !node.data.isEquivalentChild;
        }

        return f;
    }

    processCellForClipboard(params: ProcessCellForExportParams): any {
        return this.gls.isValueDisplaySuppressed(params.column.getColDef().field, params.node.data) ? undefined :
            typeof params.value === 'object' ? params.value.fieldValue : params.value;
    }

    private checkForEquivalents() {
        let equivalentsExists: boolean = false;
        if (this.data && this.data.pfSecRebalDTOList && this.data.pfSecRebalDTOList.length !== 0) {
            this.data.pfSecRebalDTOList.forEach((alloc: IPortfolioResultPFSECRebal) => {
                if (alloc.childEqvList && alloc.childEqvList.length !== 0) {
                    equivalentsExists = true;
                }
            });
        }
        this.pralloc.showEquivalents = equivalentsExists;
    }
    
    getAllocationDescription(params: any) {
        let d: string = '';

        if(params.data) {
            if(!params.data.secType || params.data.secType === "OPTION") {
                return null;
            } else if(params.data.secType === "UI_GROUP") {
                d = params.data.secSymb;
            } else {
                d = params.data.secSymb + "<br/>" + params.data.secDescription;
            }
        } else {
            d = params.value || '';
        }

        this.comPrAllocationTemplateContent = d;
        return this.comPrAllocationTemplate;
    }

    getSecurityTradeActionNoteTemplate(n: Array<SecurityTradeActionNote>) {
        this.securityTradeActionNoteTemplateContent = "";
        let c = 1;

        n.forEach((note: SecurityTradeActionNote) => {
            let s = (c++ == n.length) ? "<div>" : "<div class='block'>";
            this.securityTradeActionNoteTemplateContent += s + note.description + "</div>";
        });

        return (n.length > 0) ? this.securityTradeActionNoteTemplate : null;
    }

    showModelHistoryInRebalance() {
        let dialogData = {
            portfolioResultData: this.data
        }
        this.as.fireEvent(IrbDialogsEvents.SHOW_MODEL_USED_IN_REBALANCE_DIALOG, dialogData);
    }

    onPostSort(rowNodes: Array<any>) {
        const optionOrders: any = {};

        //remove option orders, and create a map of options using parent symbol
        for(let i = 0; i < rowNodes.length; i++) {
            if(rowNodes[i].data?.secType === "OPTION") {
                const parentSymbol = rowNodes[i].data.secSymb.split(" ")[0];

                if(typeof optionOrders[parentSymbol] === "undefined") {
                    optionOrders[parentSymbol] = [];
                }

                optionOrders[parentSymbol].push(rowNodes.splice(i--,1)[0]);
            }
        }

        //insert option orders after their parent symbol
        Object.keys(optionOrders).forEach((parentSymbol: string) => {
            for(let i = 0; i < rowNodes.length; i++) {
                if(rowNodes[i].data?.secSymb === parentSymbol) {
                    rowNodes.splice(i + 1, 0, ...optionOrders[parentSymbol]);
                    delete optionOrders[parentSymbol];
                    break;
                }
            }
        });

        //if no parent symbol is found, reinsert
        Object.keys(optionOrders).forEach((parentSymbol: string) => {
            rowNodes.push(...optionOrders[parentSymbol]);
        });
    }

    showGroupComponents(params: any) {
        if (params.data.rebalCompSecurityDTOList.length === 0) {
            this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
                dTitle: "Alert",
                msg: "There are no component securities associated with this group.",
                dProceedBtnLabel: "Ok",
                dType: "ERROR"
            } as IAlertDialogData);
            return;
        }

        const config = this.dialogPrComAlloc.getDefaultConfig();
        config.minHeight = "200px";
        config.height = "auto";
        config.width = "600px";
        config.data = {
            groupSecurity: params.data.secSymb,
            rebalCompSecurityDTOList: params.data.rebalCompSecurityDTOList
        };
        this.dialogPrComAlloc.open(SecurityComponentsDialogComponent, config);
    }

    resetGridColumns() {
        localStorage.removeItem(this.componentName);
        this.grid.api.resetColumnState();
        this.grid.api.applyColumnState({state: null });
        //this.setGroup();
        this.setColumnMode(this.columnMode);
        if(this.data.isAllocationExcludedPositionRecordsPresent) {
            this.setShowExcluded();
        }
        //this.grid.api.sizeColumnsToFit();
    }

    onPrAllocationsCellClicked(event: CellClickedEvent) {
        if(event.column.getColId() === 'ag-Grid-AutoColumn' && (
            event.column.getColDef().headerName === 'Allocation')  ) {
            if(event.node.isExpandable() && event.node.expanded) {
                event.node.setExpanded(false);
            } else if (event.node.isExpandable() && !event.node.expanded) {
                event.node.setExpanded(true);
            }
            this.updateGridLayout();
        }
    }

    expandAll() {
        this.grid?.api.expandAll();
        this.updateGridLayout();
    }

    collapseAll() {
        this.grid?.api.collapseAll();
        this.updateGridLayout();
    }

    onColumnVisible(_ev: any) {
        let sortModel = this.grid?.api.getColumnState().filter((col:any) => col.sort !== null);

        if(sortModel?.length > 0) {
            this.pdfExportConfig.allcnSortModel = [];

            sortModel.forEach((m: any) => {
                this.pdfExportConfig.allcnSortModel.push({
                    sort: m.colId,
                    order: m.sort
                } as ISortModel);
            });

            this.pdfExportConfigChange?.emit(this.pdfExportConfig);
        }
    }
}
